import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=2f81981e&scoped=true&"
import script from "./Group.vue?vue&type=script&lang=ts&"
export * from "./Group.vue?vue&type=script&lang=ts&"
import style0 from "./Group.vue?vue&type=style&index=0&id=2f81981e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f81981e",
  null
  
)

export default component.exports